import { Component, Input, OnInit } from '@angular/core';
import { IOrderLine, PRODUCT_TYPE_STRUCTURE_TYPES } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'product-tbody, tbody[product-tbody]',
  templateUrl: './product-tbody.component.html'
})
export class ProductTbodyComponent implements OnInit {
  @Input() orderLine: IOrderLine;
  @Input() currency: string;
  @Input() simplifyView = false;

  public isComplex = false;
  public isStandardVariant = false;
  public total: number;
  public price: number;

  ngOnInit() {
    if (this.orderLine.details && !this.orderLine.details.applyOnce) {
      this.isComplex = this.orderLine.details.type.structureType === PRODUCT_TYPE_STRUCTURE_TYPES.COMPLEX;
      this.isStandardVariant = this.orderLine.details.variant && this.orderLine.details.variant.isStandard;
    }

    this.price = this.orderLine.price;
    this.total = this.price * this.orderLine.quantity;
  }
}
